import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RentResumeListView from './RentResumeList';
import IncomeResumeListView from './IncomeResumeList';
import BureauReportListView from './BureauReportList';
import BuroReportDetailView from './BuroReportDetail';
import AgingBalanceView from './AgingBalance';

const IncomeView = () => (
  <Routes>
    <Route path="rent/*" element={<RentResumeListView />} />
    <Route path="resume/*" element={<IncomeResumeListView />} />
    <Route path="bureau-reports" element={<BureauReportListView />} />
    <Route path="bureau-reports/detail/:reportId/*" element={<BuroReportDetailView />} />
    <Route path="aging-balance/*" element={<AgingBalanceView />} />
  </Routes>
);

export default IncomeView;
